export const fetchMJOData = async(url, params) => {
  const options = {
    method: 'POST',
    headers: {'content-type': 'application/json'},
    body: JSON.stringify(params),
  }
  
  try {
    const response = await fetch(url, options)
    
    if (response.status !== 200) throw new Error(`Failed with status ${response.status}`)
    
    const json = await response.json()
    const {
      success, data, errorMsg, errorCode,
    } = json
    
    if (!success) {
      const error = new Error(errorMsg || errorCode)
      
      if (data) error.data = data
      
      throw error
    }
    
    if (!data) console.warn('No data returned.', json)
    
    return data || undefined
  } catch (error) {
    console.warn('MJO fetch failed', error, url, params)
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/apis/mjo.js